import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import PolicyPage, { PolicyContactBox } from "./PolicyPage";

const faqs = [
  {
    id: "faq-delivery-cost",
    title: "How much is delivery?",
    content: <p>Tracked delivery is currently {formatPrice(siteConfig.shipping.standardRate)} for supported destinations shown at checkout.</p>,
  },
  {
    id: "faq-dispatch",
    title: "When will my order dispatch?",
    content: <p>Orders normally dispatch within {siteConfig.shipping.dispatchDays}. Weekends, public holidays and peak periods may add time.</p>,
  },
  {
    id: "faq-tracking",
    title: "Can I track my order?",
    content: <p>A dispatch message should contain the carrier and tracking link. Tracking can take up to 24 hours to show the first scan.</p>,
  },
  {
    id: "faq-change-order",
    title: "Can I change or cancel an order?",
    content: <p>Email us immediately. Changes are not guaranteed after packing or payment processing begins. Read the <Link to="/orders">orders policy</Link> for details.</p>,
  },
  {
    id: "faq-payment",
    title: "How is payment handled?",
    content: <p>You continue to a hosted payment page. Do not email card details or one-time codes. The <Link to="/payments">payments policy</Link> explains authorisation and security.</p>,
  },
  {
    id: "faq-duties",
    title: "Are duties and local taxes included?",
    content: <p>Only charges shown in the checkout total are collected by the store. A destination authority or carrier may collect import duties, local taxes or handling charges separately.</p>,
  },
  {
    id: "faq-returns",
    title: "How do returns work?",
    content: <p>Contact us within 30 days of confirmed delivery before sending anything. Items should be unused, complete and safely packed. Exceptions and refund timing are in the <Link to="/returns">returns policy</Link>.</p>,
  },
  {
    id: "faq-damaged",
    title: "What if an item is damaged or wrong?",
    content: <p>Keep the item and packaging, then email the order reference and clear photographs promptly. Mandatory rights are not shortened by a requested reporting period.</p>,
  },
  {
    id: "faq-colour",
    title: "Will colour and finish match my screen?",
    content: <p>Screens and lighting vary, and natural or handmade finishes may show small differences. Product measurements and material descriptions should be checked before ordering.</p>,
  },
  {
    id: "faq-storage",
    title: "How are my cart and wishlist remembered?",
    content: <p>They are saved in local storage on the device. You can remove items in the site or clear the site’s browser data. Read the <Link to="/cookies">cookie policy</Link> for details.</p>,
  },
  {
    id: "faq-privacy",
    title: "How can I make a privacy request?",
    content: <p>Email {siteConfig.contact.email} with “Privacy request” in the subject. The <Link to="/privacy-choices">privacy choices page</Link> explains what to include.</p>,
  },
  {
    id: "faq-accessibility",
    title: "Can I request accessibility help?",
    content: <p>Yes. Tell us the page and task that caused difficulty, and we will try to provide the information or a reasonable alternative.</p>,
  },
];

export default function Faqs() {
  return (
    <PolicyPage
      activePath="/faqs"
      title="Frequently asked questions"
      intro="Quick answers about ordering, payment, delivery, returns, product care and privacy."
      sections={[
        ...faqs,
        {
          id: "faq-contact",
          shortTitle: "Still need help?",
          title: "Still need help?",
          content: (
            <>
              <p>Include an order reference when relevant, but never send full payment-card details or passwords.</p>
              <PolicyContactBox label="Customer care" />
            </>
          ),
        },
      ]}
    />
  );
}
